export const environment = {
  production: false,
  title: 'ISTARIL',
  baseUrl: 'https://istarilperu.com',
  seoDescription: 'ISTARIL Perú: Tu farmacia digital especializada. Compra ISTARIL (fentermina y topiramato) y otros tratamientos para el manejo de peso con envío seguro.',
  seoKeywords: 'istaril, Istaril Peru, fentermina, topiramato, comprar Istaril, pastillas para bajar de peso, salud mental',
  catalogFilter: ['istaril'],
  contactPhone: 'https://wa.me/51976749130',
  favicon: 'favicon-istaril.svg',
  heroTitle: 'Especialistas en<br/><span class="text-gradient">Salud Mental</span>',
  heroSubtitle: 'La farmacia líder en productos psiquiátricos en Perú. Cuidamos tu bienestar con discreción y rapidez.',
  benefits: [
    { icon: 'security', title: 'Máxima Discreción', desc: 'Tus pedidos son 100% confidenciales.' },
    { icon: 'verified', title: 'Calidad Garantizada', desc: 'Medicamentos directamente de laboratorio.' },
    { icon: 'support_agent', title: 'Asesoría Especializada', desc: 'Soporte constante para tus dudas.' }
  ]
};
